import storage from 'app/services/storage';

import { getUUID } from 'utils/uuid';

const NATIVE_DEVICE_ID_STORAGE_KEY = 'telnyxNativeDeviceId';

/**
 * Stable per-install identity for the native softphone's WebRTC credential (DEV-6051). No existing
 * Capacitor plugin, NativeCalling transport, or repo util already exposes a device identifier
 * (no `@capacitor/device` dependency), so a UUID is generated once and persisted in localStorage —
 * it survives app restarts and backgrounding, and is re-minted only on reinstall (new DeviceId,
 * replacing the old credential per the DEV-6047 reap design).
 */
export const getOrCreateNativeDeviceId = () => {
  const existing = storage.getItem(NATIVE_DEVICE_ID_STORAGE_KEY);

  if (existing) {
    return existing;
  }

  const deviceId = getUUID();

  storage.setItem(NATIVE_DEVICE_ID_STORAGE_KEY, deviceId);

  return deviceId;
};
